export const rfiCapabilityTypeMapper = {
  finishedgood: 'Finished Goods',
}
